<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-no"><span>3</span></p>
<p class="normal">Dortmunder had walked three blocks along Merrick Avenue, swinging his almost-empty attaché case, when the purple Toronado pulled to the curb beside him again and Kelp shouted, ‘Hey, Dortmunder! Get in!’</p>
<p class="indent">Dortmunder leaned down to look through the open right-side window. ‘I’ll take the train,’ he said. ‘Thanks, anyway.’ He straightened and walked on.</p>
<p class="indent">The Toronado shot past him, went down a line of parked cars and pulled in by a fire hydrant. Kelp jumped out, ran around the car and met Dortmunder on the sidewalk. ‘Listen,’ he said.</p>
<p class="indent">‘Things have been very quiet,’ Dortmunder told him. ‘I want to keep it that way.’</p>
<p class="indent">‘Is it my fault that guy ran into me in the back?’</p>
<p class="indent">‘Have you seen the back of that car?’ Dortmunder asked him. He nodded at the Toronado, which he was even then walking past.</p>
<p class="indent">Kelp fell into step beside him. ‘What do I care?’ he said. ‘It’s not mine.’</p>
<p class="indent">‘It’s a mess,’ Dortmunder said.</p>
<p class="indent">‘Listen,’ Kelp said. ‘Don’t you want to know what I was looking for you for?’</p>
<p class="indent">‘No,’ Dortmunder said. He kept walking.</p>
<p class="indent">‘Where the hell you walking to, anyway?’</p>
<p class="indent">‘That railroad station down there.’</p>
<p class="indent">‘I’ll drive you.’</p>
<p class="indent">‘You sure will,’ Dortmunder said. He kept walking.</p>
<p class="indent">‘Listen,’ Kelp said. ‘You’ve been waiting for a big one, am I right?’</p>
<p class="indent">‘Not again,’ Dortmunder said.</p>
<p class="indent">‘Will you listen? You don’t want to spend the rest of your life peddling encyclopedias around the Eastern Seaboard, do you?’</p>
<p class="indent">Dortmunder said nothing. He kept walking.</p>
<p class="indent">‘Well, do you?’</p>
<p class="indent">Dortmunder kept walking.</p>
<p class="indent">‘Dortmunder,’ Kelp said, ‘I swear and vow I have the goods. This time I have a guaranteed winner. A score so big you can retire for maybe three years. Maybe even four.’</p>
<p class="indent">‘The last time you came to me with a score,’ Dortmunder said, ‘it took five jobs to get it, and even when I got it I didn’t have anything.’ He kept walking.</p>
<p class="indent">‘Is that my fault? Luck ran against us, that’s all. The idea of the caper was first-rate, you got to admit that yourself. Will you for Christ’s sake stop walking?’</p>
<p class="indent">Dortmunder kept walking.</p>
<p class="indent">Kelp ran around in front of him and trotted backward for a while. ‘All I’m asking,’ he said, ‘is that you listen to it and come look at it. You know I trust your judgment; if you say it’s no good I won’t argue for a minute.’</p>
<p class="indent">‘You’re gonna fall over that Pekingese,’ Dortmunder said.</p>
<p class="indent">Kelp stopped running backward, turned around, glared back at the woman who owned the Pekingese, and reverted to walking frontward, on Dortmunder’s left. ‘I think we been friends long enough,’ he said, ‘that I can ask you as a personal favor just to give me a listen, just to give the job a look-see.’</p>
<p class="indent">Dortmunder stopped on the sidewalk and gave Kelp a heavy look. ‘We been friends long enough,’ he said, ‘that I know if you come up with a job, there’s something wrong with it.’</p>
<p class="indent">‘That isn’t fair.’</p>
<p class="indent">‘I never said it was.’</p>
<p class="indent">Dortmunder was about to start walking when Kelp quickly said, ‘Anyway, it isn’t my caper. You know about my nephew Victor?’</p>
<p class="indent">‘No.’</p>
<p class="indent">‘The ex-F.B.I. man? I never told you about him?’</p>
<p class="indent">Dortmunder looked at him. ‘You have a nephew who’s an F.B.I, man?’</p>
<p class="indent">‘<i>Ex</i>-F.B.I. man. He quit.’</p>
<p class="indent">‘He quit,’ Dortmunder echoed.</p>
<p class="indent">‘Or maybe they fired him,’ Kelp said. ‘It was some argument about a secret handshake.’</p>
<p class="indent">‘Kelp, I’m gonna miss my train.’</p>
<p class="indent">‘I’m not making this up,’ Kelp said. ‘Don’t blame me, for Christ’s sake. Victor kept sending in these memos how the F.B.I. ought to have a secret handshake, so the agents could tell each other at parties and like that, and they never went for it. So either he quit or they fired him, something like that.’</p>
<p class="indent">‘This is the guy that came up with the caper?’</p>
<p class="indent">‘Look, he was <i>in</i> the F.B.I., he passed the tests and everything, he isn’t a nut. He’s got a college education and everything.’</p>
<p class="indent">‘But he wanted them to have a secret handshake.’</p>
<p class="indent">‘Nobody’s perfect,’ Kelp said reasonably. ‘Hey, listen, will you come meet him, listen to him? You’ll like Victor. He’s a nice guy. And I tell you the score is guaranteed beautiful.’</p>
<p class="indent">‘May’s waiting for me to come home,’ Dortmunder said. He could feel himself weakening.</p>
<p class="indent">‘I’ll give you the dime,’ Kelp said. ‘Come on, whadaya say?’</p>
<p class="indent">‘I’m making a mistake,’ Dortmunder said, ‘that’s what I say.’ He turned around and started walking back. After a second, Kelp caught up with him again, smiling cheerfully, and they walked back together.</p>
<p class="indent">The Toronado had a ticket on it.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?136acf3c